import { Component, Shark } from "shark-mvc";
import { NousCore } from "nouscore-js-api";
import Tagify from "@yaireo/tagify";

import templateContent from "./tags-card.html";
import "./style.css";

class TagsComponent extends Component {
	constructor () {
		super("tagsComponent");

		this.addTemplate("", templateContent);
	}

	setup () {
		const tagContainer = document.querySelector("#tagsComponentTagsField");

		if (tagContainer) {
			this.tagify = new Tagify(tagContainer, {
				autoComplete: { rightKey: true},
				templates: {
					tag(tagData, {settings: _s}) {
						let tagIcon = "";

						switch (tagData.type) {
							case "for-related-image":
								tagIcon = `<i class="bi bi-file-image me-1" title="Tag relativo ad un'immagine collegata"></i>`;
								break;
							case "page-number":
								tagIcon = `<i class="bi bi-file-earmark me-1" title="Pagina in cui si trova questo contenuto"></i>`;
								break;
							case "person":
								tagIcon = `<i class="bi bi-file-person me-1"></i>`;
								break;
							case "people-folk":
								tagIcon = `<i class="bi bi-people-fill me-1"></i>`;
								break;
							case "place":
								tagIcon = `<i class="bi bi-geo-alt-fill me-1"></i>`;
								break;
						}

						return `<tag title="${(tagData.title || tagData.value)}"
									contenteditable='false'
									tabIndex="${_s.a11y.focusableTags ? 0 : -1}"
									class="${_s.classNames.tag} ${tagData.class || ""}"
									${this.getAttributes(tagData)}>
							<x title='' tabIndex="${_s.a11y.focusableTags ? 0 : -1}" class="${_s.classNames.tagX}" role='button' aria-label='remove tag'></x>
							<div>
								${tagIcon}
								<span ${_s.mode === "select" && _s.userInput ? "contenteditable='true'" : ""} autocapitalize="false" autocorrect="off" spellcheck='false' class="${_s.classNames.tagText}">${tagData[_s.tagTextProp] || tagData.value}</span>
							</div>
						</tag>`;
					}
				},
				transformTag: data => {
					console.log({data});

					if (data.value.includes(":")) {
						let tagType = data.value.slice(0, data.value.indexOf(":"));
	
						switch (tagType) {
							case "img":
								tagType = "for-related-image";
								break;
							case "people":
								tagType = "people-folk";
								break;
						}
	
						data.source = "manual";
						data.type = tagType;
						data.value = data.value.slice(data.value.indexOf(":") + 1);
					}
					else if (data.value.slice(0, 3).toLowerCase() === "pag" && !isNaN(parseInt(data.value.slice(3))) && !data.type) {
						data.source = "manual";
						data.type = "page-number";
					}
				}
			});//, {whitelist:[]}
			this.tagify.on("input", this.onInput);
			this.tagify.on("add", event => {
				// if added alidays
				const value = event.detail.data.value;
				const tagParentToAdd = ["shopping", "intrattenimento", "vita notturna", "celebrità", "sport"].includes(value) ? "tempo libero" : ["arte", "storia", "architettura", "città", "musica", "cinema"].includes(value) ? "cultura" : ["paesaggi", "mare", "animali", "benessere", "cibo"].includes(value) ? "natura" : "";

				if (tagParentToAdd) {
					if (this.tagify.value.filter(item => item.value === tagParentToAdd).length === 0) {
						this.tagify.addTags([{ source: "auto-related", type: "theme", value: tagParentToAdd }]);
					}
				}

				// if (value.includes(":")) {
				// 	event.preventDefault();

				// 	let tagType = value.slice(0, value.indexOf(":"));

				// 	switch (tagType) {
				// 		case "img":
				// 			tagType = "for-related-image";
				// 			break;
				// 	}

				// 	this.tagify.addTags([{ source: "manual", type: tagType, value: value.slice(value.indexOf(":") + 1) }]);
				// }
			});
			return true;
		}
		else {
			return false;
		}
	}

	onInput (event) {
		// console.log(event);
		const value = event.detail.value;

		if (value.trim() !== "") {
			event.detail.tagify.whitelist = null; // reset the whitelist

			// https://developer.mozilla.org/en-US/docs/Web/API/AbortController/abort
			tagsComponent.controller && tagsComponent.controller.abort();
			tagsComponent.controller = new AbortController();

			// show loading animation and hide the suggestions dropdown
			event.detail.tagify.loading(true).dropdown.hide();

			const rd = NousCore.api.createRequest({ item: { searchKey: value } });

			const request = {
				payload: rd,
				__nctoken__: localStorage["NousCore.api.last_token"],
				__ukey__: "",
			};

			let targetApiEndPoint = "";

			switch (Shark.activePage.id) {
				case "imageContentView":
					targetApiEndPoint = "image-content";
					break;
				case "placeContentView":
					targetApiEndPoint = "place-content";
					break;
				case "textContentView":
					targetApiEndPoint = "text-content";
					break;
			}

			// fetch(`https://wscontenutidigitali.lineacontinua.net/api/${targetApiEndPoint}/search-internal-tags`, {
			fetch(`${Shark.$store.apiURL}/${targetApiEndPoint}/search-internal-tags`, {
				body: JSON.stringify(request),
				method: "POST",
				signal: tagsComponent.controller.signal,
			})
			.then(RES => RES.json())
			.then(function(data){
				const newWhitelist = new Set();
				data.payload.items.forEach(item => {
					JSON.parse(item.tags)?.forEach(tag => {
						newWhitelist.add(tag.value.toLowerCase());
					});
				});
				
				console.log({data, newWhitelist});

				event.detail.tagify.whitelist = Array.from(newWhitelist); // update whitelist Array in-place
				event.detail.tagify.loading(false).dropdown.show(value); // render the suggestions dropdown
			});
		}
	}
}

const tagsComponent = new TagsComponent();

Shark.registerComponent(tagsComponent);

export default tagsComponent;
